export default __webpack_public_path__ + "static/media/Gestao-Projetos-PT.f2ae2c95.png";